import {Component} from 'react'
import PropTypes from 'prop-types'
import {getCurrentStore, getCurrentStoreSettings, refreshStoreSettings} from '../services/CurrentStoreServices'
import { fetchPublicStoreSettingsBySlug } from '../services/SellerServices'

class WithStoreSettings extends Component {
    state = {
        storeId: getCurrentStore(),
        settings: getCurrentStoreSettings(),
    }

    _handleAuthChange = () => {
        this.setState({
            storeId: getCurrentStore(),
            settings: getCurrentStoreSettings(),
        })
    }

    _getSetting = (key, defaultValue = null) => {
        const {settings} = this.state

        if (!settings || !Array.isArray(settings)) return defaultValue
        const setting = settings.find((setting) => setting.key === key)
        if (!setting) return defaultValue

        const {value} = Object.assign({}, setting)

        return value || defaultValue
    }

    _hasFeature = (feature) => {
        if (!feature || typeof feature !== 'string') return false

        const featureTags = this._getSetting('feature_tags', [])

        if (!Array.isArray(featureTags)) return false

        return featureTags.includes(feature)
    }

    _hasStoreRole = (allowRole) => {
        const {roles} = this.state
        const vRoles = Array.isArray(roles) ? roles : []

        if (Array.isArray(allowRole)) {
            return allowRole.some((role) => vRoles.includes(role))
        }

        return vRoles.includes(allowRole)
    }

    _refreshSettings = async () => {
        const {storeId} = this.state

        if (!storeId) return false

        try {
            const {success, data, message} = await fetchPublicStoreSettingsBySlug(storeId)

            if (!success) {
                return console.error(message)
            }

            refreshStoreSettings(data)
        } catch (e) {
            console.error(e)
        }

        return true
    }

    render() {
        return this.props.children({
            ...this.state,
            getSetting: this._getSetting,
            hasFeature: this._hasFeature,
            refresh: this._refreshSettings,
            hasStoreRole: this._hasStoreRole,
        })
    }
}

WithStoreSettings.propTypes = {
    children: PropTypes.func.isRequired,
}

export default WithStoreSettings
